import { Inject, Input, Component, OnInit, HostListener, ViewEncapsulation, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { OvsComponent, Core, LabelNames, ApplicationConfiguration, QueryParamService, Menu } from '../../shared/core/ovs.core';
import { PartnerHeaderComponent } from '../partner-header/partner-header.component';
import { DOCUMENT } from "@angular/platform-browser";
import { ResortComponent } from '../../shared/resort.component';
import { Router } from '@angular/router';
import { Animations } from '../../shared/animations/animations';
import { ResortHeaderLabelNames } from '../resort-header-labels-names';
import { ResortApplicationConfiguration } from '../../models/presentation.model';

@Component({
  selector: 'header-v2',
  templateUrl: './header-v2.component.html',
  styleUrls: ['./header-v2.component.scss'],
  animations: [Animations.slideInOut],
  host: {
    "(document:click)": "hideDropDown($event)"
  },
  encapsulation: ViewEncapsulation.None
})
export class HeaderV2Component extends ResortComponent implements OnInit {
  private _document: Document;
  private _router: Router;
  private _core: Core;
  private _qryParamService: QueryParamService;


  public logoUrl: string;
  public myAccountHRef: string;
  public myAccountText: string;
  public phoneNumber: string;
  public logoNavigationUrl: string;
  public isNavFixed: boolean;
  public secondaryLogoUrl: string;
  public secondaryLogoText: string;
  public showMobile: boolean;
  public isMobile: boolean;
  
  public userName: string = '---';
  public userLinkText: string = 'Users';
  public userHRef: string = '#';
  public redeemText: string = 'Redeem';
  public redeemHRef: string = '#'
  public bookingActivityText : string = 'Booking Activity';
  public bookingActivityHRef : string = '#'
  public signOutText: string = 'Sign Out';
  public signOutHRef: string = '#'

  // public myAccountHRef: string = "#";
  public activeTabIndex: number = 1;
  public menusCollection: Menu[][];

  
  public currencyLabel: string = '';
  public currencyBalance: number;
  
  public get hasPartnerBadge(): boolean {
    return this.application.configuration.HeaderDisplayOptions.HasPartnerBadge;
  }
  
  // Get Display option label keys and values

  public getLabel(key: string): string {
    const contextKey = ResortHeaderLabelNames[key];
    return Core.current.getLabel(contextKey);
  }

  public getKey(key: string): string {
    return ResortHeaderLabelNames[key];
  }

  @ViewChild('accountBtn') accountBtn: ElementRef;
  
  constructor( @Inject(DOCUMENT) document: Document, router: Router, core: Core, qryParamService: QueryParamService, private cdr:ChangeDetectorRef) {
    super();
    this._document = document;
    this._router = router;
    this._core = core;
    this._qryParamService = qryParamService;
   
    // // mobile window resize
    let checkIsMobile = () => {
      return window.innerWidth < 991;
    };
    
    this.isMobile = checkIsMobile();
    
    window.onresize = () => {
      let prevIsMobile = this.isMobile;
      this.isMobile = checkIsMobile();
      if (prevIsMobile !== this.isMobile) {
        this.activeTabIndex = 1;
        if (!this.isMobile) {
          this.hideMobileMenu();
        }
      }
      this.cdr.detectChanges();
    };
  }
  
  public initialize(): void {
    super.initialize();
    this.breakDownMenus();
  }

  private breakDownMenus(): void{
    this.menusCollection = new Array<Array<Menu>>();

     let menuIndex: number = 0;
     let i:number= 0;
     this.menusCollection[menuIndex] = new Array<Menu>()
     this.application.configuration.Menus.forEach(m =>
      {
        if(m.IsSeparator){
          menuIndex++;
          this.menusCollection[menuIndex] = new Array<Menu>();
          i=0;
        }
        else {
          this.menusCollection[menuIndex][i] = m;
          i++;
        }
      });
  }

  public showMobileMenu() {
    document.body.classList.add("modal-open");
    this.showMobile = true;
  }

  public hideMobileMenu() {
    document.body.classList.remove("modal-open");
    this.showMobile = false;
  }
  public switchTab(ev) {
    console.log(ev);
    switch(ev.nextId) {
      case "ngb-shop-tab":
        this.activeTabIndex = 0;
        break;
      case "ngb-menu-tab":
        this.activeTabIndex = 1;
        break;
    }
  }
  
  toggleDropdown: boolean = false;
  public userDropdown() {
    this.toggleDropdown = !this.toggleDropdown
  }

  public hideDropDown(event) {
    if (!this.accountBtn.nativeElement.contains(event.target)) {
      this.toggleDropdown = false;
    }
  }
  protected configurationChanged(): void {
    let config: ApplicationConfiguration = this.configuration;
    this.logoUrl = config.Logos ? config.Logos.first().ImageUrl : "";
    this.logoNavigationUrl = config.Logos ? config.Logos.first().NavigationUrl : "";
    this.phoneNumber = config.Partner ? config.Partner.PhoneNumber : "---";
    this.currencyBalance =  config.Member.VCBalance;
    this.userName = config.Member.FirstName + ' ' + config.Member.LastName;

     }



  @HostListener('window:scroll', [])
  public onWindowScroll() {
    const number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (number > 150) {
      this.isNavFixed = true;
    } else if (this.isNavFixed && number < 10) {
      this.isNavFixed = false;
    }
  }
  
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/header/header-v2/header-v2.component.ts